import React from "react";
import {Bar} from "react-chartjs-2";
import "./SmartUsageScheduler.scss";
import WidgetHeader from "../WidgetHeader";
import GridDuck from 'gridduck';
import formatter from "../../../../services/formatter";

class SmartUsageScheduler extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            showLegend: false,
            compressorVisible: true
        };
        this.chartRef = React.createRef();
    }

    async componentDidMount() {
        // req.query.site_id, req.query.start
        console.log(this.props, ' : smart usage props');
        const forecastRes = await GridDuck.getEnergyMasterTests({
            filters: [
                {
                    field: 'siteId',
                    value: this.props.item.id
                },
                {
                    field: 'start',
                    value: Date.now()
                }
            ]
        });
        let data, startHour;
        if (forecastRes.list?.length > 0) {
            const forecast = forecastRes.list[0].dataJson
            console.log(forecast, ' : forecast res');
            const startDate = new Date(forecast.forecasted_start);
            startHour = startDate.getHours(); // e.g., 9
            data = forecast.consumption.map((value, i) => ({
                time: i, // hour of day
                solar: forecast.solar_production[i],
                consumption: forecast.consumption[i],
                flexible: forecast.flexible_consumption[i],
            }));
        }

        this.setState({
            ready: true,
            data,
            startHour
        });
    }

    generateHourLabels(startHour) {
        return Array.from({length: 24}, (_, i) => {
            const hour = (startHour + i) % 24;
            return `${String(hour).padStart(2, '0')}:00`;
        });
    }

    getChartData() {
        const labels = this.generateHourLabels(0);
        console.log(this.state.data, ' : this.state.data');

        const compressorOn = this.state.compressorVisible;

        const usageBar = this.state.data.map(d =>
            Math.min(
                d.consumption - d.flexible,
                d.solar
            )
        );

        const flexibleUsage = this.state.data.map(d =>
            compressorOn ? d.flexible : "0"
        );

        this.solar = this.state.data.map(d =>
            d.solar
        );

        const totalConsumption = this.state.data.map(d => compressorOn ? d.consumption : d.consumption - d.flexible);

        const solarUsed = this.state.data.map((d, i) =>
            Math.min(d.solar, totalConsumption[i])
        );

        const solarSurplus = this.state.data.map((d, i) =>
            Math.max(d.solar - totalConsumption[i], 0)
        );

        console.log(flexibleUsage, ' : flexibleUsage');

        const allValues = this.state.data.flatMap(d => [
            d.solar,
            compressorOn ? d.consumption : d.consumption - d.flexible
        ]);

        this.globalMax = Math.ceil(Math.max(...allValues) * 1.1);
        this.globalMin = Math.floor(Math.min(...allValues) * 1.1);

        // const totalDemand = this.state.data.map(d =>
        //     compressorOn ? d.consumption : d.consumption - d.flexible
        // );

        // const surplusBar = this.state.data.map((d, i) =>
        //     Math.max(d.solar - totalDemand[i], 0)
        // );
        //
        // const deficitBar = this.state.data.map((d, i) =>
        //     Math.max(totalDemand[i] - d.solar, 0)
        // );
        // TODO Fix to get this data from the assets that have flexible true in site from the API

        let flexLabel = '';
        switch (this.props.filterId) {
            case '451b0547-9ba4-4e2b-9c99-1e67c5348ad5' :
                flexLabel = 'P11-Compressorruimte V30'
                break;
            case '2a6928f8-5b57-454d-9e14-c8015ad6e374' :
                flexLabel = 'Compress Via Grieco'
                break;
            case '5d22064d-d40e-4ef3-91ee-ccf563e401db' :
                flexLabel = 'Compress_Viale_Europa'
        }
        return {
            labels,
            datasets: [
                {
                    label: "Total Consumption",
                    borderColor: 'rgb(255, 202, 0)',
                    borderWidth: 2,
                    data: totalConsumption,
                    yAxisID: 'y-line',
                    type: 'line',
                    fill: true,
                    tension: 0.1,
                    backgroundColor: "rgba(255, 202, 0, 0.2)",
                    pointRadius: 0,        // 👈 Hides all point markers
                    pointHoverRadius: 4   // 👈 Optional: small dot on hover only
                },
                {
                    label: `${flexLabel}`,
                    type: 'line',
                    borderColor: 'rgba(255,138,0,0.7)',
                    borderWidth: 2,
                    yAxisID: 'y-line',
                    fill: true,
                    backgroundColor: "rgba(255, 138, 0, 0.2)",
                    data: flexibleUsage,
                    pointRadius: 0,        // 👈 Hides all point markers
                    pointHoverRadius: 4   // 👈 Optional: small dot on hover only
                },
                {
                    label: "Solar Consumption",
                    backgroundColor: "rgb(255, 202, 0)",
                    yAxisID: 'y-bar',
                    data: solarUsed,
                    stack: "stack1",
                },
                {
                    label: "Solar Surplus",
                    backgroundColor: "rgb(58, 213, 110)",
                    yAxisID: 'y-bar',
                    data: solarSurplus,
                    stack: "stack1",
                }
            ],

        };
    }

    generateRecommendations() {
        const surplusThreshold = 0;

        const pureSurplusWindows = [];
        const extraSurplusWithCompressorWindows = [];

        let currentWindow = null;
        let extraWindow = null;

        const data = this.state.data;

        for (let i = 0; i < data.length; i++) {
            const d = data[i];

            // 👇 Compressor treated as OFF
            const baseDemand = d.consumption - d.flexible;
            const baseSurplus = d.solar - baseDemand;

            if (baseSurplus > surplusThreshold) {
                if (!currentWindow) currentWindow = {start: i, end: i};
                else currentWindow.end = i;
            } else if (currentWindow) {
                pureSurplusWindows.push(currentWindow);
                currentWindow = null;
            }

            // 👇 Compressor treated as ON
            const fullDemand = d.consumption;
            const fullSurplus = d.solar - fullDemand;

            if (fullSurplus > surplusThreshold) {
                if (!extraWindow) extraWindow = {start: i, end: i};
                else extraWindow.end = i;
            } else if (extraWindow) {
                extraSurplusWithCompressorWindows.push(extraWindow);
                extraWindow = null;
            }
        }

        if (currentWindow) pureSurplusWindows.push(currentWindow);
        if (extraWindow) extraSurplusWithCompressorWindows.push(extraWindow);

        const hasSurplus = pureSurplusWindows.length > 0;

        const headline = hasSurplus
            ? "Surplus generation expected during parts of the day."
            : "No surplus generation expected today.";

        if (!hasSurplus) {
            return [
                headline,
                "No significant surplus periods were detected. It may be a good time to consider reducing demand or using stored energy."
            ];
        }

        const suggestions = [];
        let compressorName = "";

        switch (this.props.filterId) {
            case '451b0547-9ba4-4e2b-9c99-1e67c5348ad5':
                compressorName = 'P11-Compressorruimte V30';
                break;
            case '2a6928f8-5b57-454d-9e14-c8015ad6e374':
                compressorName = 'Compress Via Grieco';
                break;
            case '5d22064d-d40e-4ef3-91ee-ccf563e401db':
                compressorName = 'Compress_Viale_Europa';
                break;
            default:
                compressorName = 'the compressor';
        }

        const formatWindow = ({start, end}, msg) => {
            const startHour = data[start].time;
            const endHour = (data[end].time + 1) % 24;
            const startTime = `${String(startHour).padStart(2, '0')}:00`;
            const endTime = `${String(endHour).padStart(2, '0')}:00`;
            return (
                <span key={`${msg}-${start}-${end}`}>
                From <span className="bold">{startTime} to {endTime}</span> {msg} <span
                    className="bold">{compressorName}</span>.
            </span>
            );
        };

        const baseUseSuggestions = pureSurplusWindows.map(w =>
            formatWindow(w, "would be a good time to use")
        );

        const bonusSuggestions = extraSurplusWithCompressorWindows.map(w =>
            formatWindow(w, "you will continue to have an additional surplus whilst running")
        );

        return [headline, ...baseUseSuggestions, ...bonusSuggestions];
    }


    render() {
        let self = this;
        if (!this.state.ready) return null;
        if (this.state.data) {
            const chartData = this.getChartData();
            const chartOptions = {
                responsive: true,
                legend: {
                    position: 'bottom',
                    onClick: (e, legendItem) => {
                        const chartWrapper = this.chartRef.current;
                        if (!chartWrapper) return;

                        const chart = chartWrapper.chartInstance;
                        const index = legendItem.datasetIndex;
                        const meta = chart.getDatasetMeta(index);

                        // Toggle dataset visibility
                        meta.hidden = meta.hidden === null
                            ? !chart.data.datasets[index].hidden
                            : null;
                        chart.update();

                        // Toggle compressorVisible state
                        const clickedLabel = legendItem.text;
                        if (
                            clickedLabel === 'P11-Compressorruimte V30' ||
                            clickedLabel === 'Compress Via Grieco' ||
                            clickedLabel === 'Compress_Viale_Europa'
                        ) {
                            this.setState(prev => ({
                                compressorVisible: !prev.compressorVisible
                            }), () => {
                                // This ensures chart + recommendations re-calc with updated state
                                this.forceUpdate(); // triggers re-render immediately with updated logic
                            });
                        }
                    }
                },
                title: {
                    display: false,
                    text: "Energy Usage with Surplus/Deficit per Hour",
                },
                tooltips: {
                    mode: "index",
                    intersect: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                            const value = tooltipItem.yLabel.toFixed(2);
                            return `${datasetLabel}: ${value} kWh`;
                        },
                        afterBody: function (tooltipItems, data) {
                            const idx = tooltipItems[0].index;

                            // Return Total Solar first, before Solar Used and Surplus appear
                            return [`Total Solar: ${self.solar[idx].toFixed(2)} kWh`];
                        }
                    }
                }

                ,
                scales: {
                    xAxes: [
                        {
                            stacked: true,
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                callback: function (value, index, values) {
                                    if (index === 0 || index === Math.floor(values.length / 2) || index === values.length - 2) {
                                        return value;
                                    }
                                    return "";
                                },
                                minRotation: 0,
                                maxRotation: 0
                            },
                            offset: true, // adds padding on both ends of the axis
                        },
                    ],
                    yAxes: [
                        {
                            id: 'y-bar',
                            stacked: true, // ✅ stack the bars
                            ticks: {
                                beginAtZero: true,
                                max: this.globalMax,
                                min: this.globalMin,
                                display: false,
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                        {
                            id: 'y-line',
                            stacked: false, // ✅ don’t stack lines
                            ticks: {
                                beginAtZero: true,
                                max: this.globalMax,
                                min: this.globalMin,
                                display: false,
                            },
                            gridLines: {
                                display: false,
                            },
                        },
                    ],

                },

            };

            const recommendations = this.generateRecommendations();

            return (
                <div
                    className={"widget smart-usage-scheduler" + (!this.state.ready ? "loading" : "") + (this.state.showLegend ? " show-legend" : "")}>
                    <WidgetHeader
                        info={{
                            title: "Today's Usage Predictions",
                            type: this.props.type,
                            dataType: this.dataType,
                            icon: this.props.icon,
                            color: this.props.color,
                            dateData: this.props.dateData,
                            className: this.props.className,
                            item: this.props.item,
                            graphType: "bar",
                            widgetType: "forecast",
                            widget: this.props.widget,
                        }}
                    />

                    <div className="chart-container">
                        <Bar ref={this.chartRef} data={chartData} options={chartOptions}/>
                    </div>

                    <div className="recommendations">
                        {/*<h5>Energy Forecast</h5>*/}
                        <p><strong>{recommendations[0]}</strong></p>
                        <div className="detailed-recommendations">
                            {recommendations.slice(1).map((rec, i) => (
                                <p key={i}>{rec}</p>
                            ))}
                        </div>
                    </div>

                </div>
            );
        } else {
            return <div>
                <div
                    className={"widget smart-usage-scheduler" + (!this.state.ready ? "loading" : "") + (this.state.showLegend ? " show-legend" : "")}>
                    <WidgetHeader
                        info={{
                            title: "Today's Usage Predictions",
                            type: this.props.type,
                            dataType: this.dataType,
                            icon: this.props.icon,
                            color: this.props.color,
                            dateData: this.props.dateData,
                            className: this.props.className,
                            item: this.props.item,
                            graphType: "bar",
                            widgetType: "forecast",
                            widget: this.props.widget,
                        }}
                    />

                    <div className="no-prediction">
                        No prediction available
                    </div>

                </div>
            </div>
        }
    }
}

export default SmartUsageScheduler;
